import { useRoleLayout } from "../hooks/useRoleLayout";
import SubUserUpdateComponent from "../components/SubUserUpdateComponent.jsx";

const SubUserUpdate = () => {
  const { Layout: RoleLayout } = useRoleLayout();
  return (
    <RoleLayout>
    
      <SubUserUpdateComponent/>
     
    </RoleLayout>
  );
};

export default SubUserUpdate;
